<template>
    <ul class="l-ss-c-completions-tags-group">
        <li
            v-for="(tag, index) in sliceTags"
            :key="`tag-${index}`"
            class="l-ss-c-completions-tags"
            @click="handleTagsClick($event, tag, index)">
            {{ isTapsComplitions ? tag.label : tag }}
        </li>
    </ul>
</template>
<script>

    const COUNT_OFFER_TAG = 4;

    export default {
        props: {
            data: {
                type: Array,
                default: () => ([]),
            },
            isTapsComplitions: {
                type: Boolean,
                default: false,
            },
            query: {
                type: String,
                default: '',
            },
            count: {
                type: Number,
            },
        },
        computed: {
            tags() {
                if (this.query && this.data.length > COUNT_OFFER_TAG) {
                    let uniqueTagsArr = this.factoryUniqueTags(this.query);
                    if (uniqueTagsArr.length === 1) {
                        const oldTag = uniqueTagsArr[0];
                        const newQuery = this.factoryQuery(this.query , uniqueTagsArr[0]);
                        const newTag = this.factoryUniqueTags(newQuery);
                        if (newTag) {
                            uniqueTagsArr = newTag.map(el => {
                                return oldTag + ' ' + el;
                            });
                        } else {
                            uniqueTagsArr = [oldTag];
                        }
                    }
                    return uniqueTagsArr;
                }
                return [];
            },
            sliceTags() {
                return this.isTapsComplitions ? this.data.slice(0, this.count) : this.tags.slice(0, this.count);
            },
        },
        methods: {
            handleTagsClick(event, tag, index) {
                const query = this.isTapsComplitions ? tag.query : this.factoryQuery(this.query, tag);

                const formatTags = this.isTapsComplitions ? this.sliceTags.map(tag => tag.query) : this.sliceTags;

                const trackParams = {
                    pos: index + 1,
                    selectTag: this.isTapsComplitions ? tag.query : tag,
                    tags: formatTags,
                    event,
                };

                this.$emit('handle-tags-click', query);

                if (!this.isTapsComplitions) {
                    this.$emit('result-tab-click', {
                        type: 'resultTabClick',
                        ...trackParams,
                    });
                } else {
                    this.$emit('preview-tab-click', {
                        type: 'previewTabClick',
                        ...trackParams,
                    });
                }
            },
            factoryQuery(query , tag) {
                let result = '';
                query = query.toLowerCase().trim();
                const queryArr = query.split(' ');
                const lastQuery = queryArr.at(-1);

                if (lastQuery !== tag && tag.includes(lastQuery)) {
                    queryArr[queryArr.length - 1] = tag;
                    result = queryArr.join(' ');
                } else if (!tag.includes(query)) {
                    result = query + ' ' + tag;
                }
                return result;
            },
            factoryUniqueTags(query) {
                query = query.toLowerCase().trim();
                const queryArr = query.split(' ');
                const queryArrLastIndex = queryArr.length - 1;
                const firstQuery = queryArr[0];
                const lastQuery = queryArr[queryArrLastIndex];
                let quantityOfHints = 0;
                let tags = this.data.map(one => {
                    let arrText = [];
                    function tagsComplite(text) {
                        arrText = (text) ? text.toLowerCase()
                            .split(' ')
                            .map(el => {
                                // eslint-disable-next-line
                                return el.replace(/[^a-zа-яё\d%,\-#№\\]/gi, ' ')
                                    .trim()
                                    .replace(/,$/gi, '');
                            })
                            .filter(el => el.length) : [];
                        arrText = arrText.join().split(/[\s,]+/);
                    }
                    if (one._text) {
                        tagsComplite(one._text);
                    } else if (one.name) {
                        tagsComplite(one.name);
                    }
                    const textString = arrText.join(' ');

                    const overlapText = arrText.map( arrTextOne => {
                        ++quantityOfHints;
                        if (query.indexOf(arrTextOne) === 0) {
                            const queryIndex = textString.indexOf(query);
                            const trimmedText = (query.length === 1) ?
                                textString.substring(queryIndex - 1) :
                                textString.substring(queryIndex);
                            const trimmedTextArray = trimmedText.split(' ');

                            if (trimmedText.indexOf(query) === 0) {
                                if (trimmedText.indexOf(lastQuery) === 0 && trimmedTextArray[0] !== firstQuery) {
                                    return trimmedTextArray[queryArrLastIndex];
                                } else if (lastQuery !== trimmedTextArray[queryArrLastIndex]) {
                                    return trimmedTextArray[queryArrLastIndex];
                                } else {
                                    const tagWord = trimmedTextArray[queryArr.length];
                                    if (tagWord?.length === 1) {
                                        return (trimmedTextArray[queryArr.length + 1]) ?
                                            tagWord + ' ' + trimmedTextArray[queryArr.length + 1] : '';
                                    }
                                    if (tagWord === query) {
                                        return trimmedTextArray[queryArr.length + 1];
                                    }
                                    return tagWord;
                                }
                            }
                        } else if (arrTextOne.indexOf(query) === 0) {
                            return arrTextOne;
                        }
                    });
                    return overlapText;
                })
                    .join()
                    .split(',');

                if (quantityOfHints === 1) {
                    tags = [];
                }
                return Array.from(new Set(tags)).filter(el => el);
            },
        },
    };
</script>